import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InternalHeader from "../components/InternalHeader";
import { api } from "../lib/api";
import { useLocale } from "../context/Locale";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState("email");
  const [form, setForm] = useState({ email: "", code: "", password: "", confirmation: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const { t } = useLocale();

  function update(name, value) {
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    setMessage("");
    try {
      if (step === "email") {
        const response = await api("/send-password-reset-mail", {
          method: "POST",
          body: JSON.stringify({ email: form.email.trim() }),
        });
        if (!response.success) throw new Error(response.error_code === "UNF" ? "No encontramos una cuenta con ese correo." : "No se pudo enviar el código.");
        setMessage("Enviamos un código de seis caracteres a tu correo.");
        setStep("code");
      } else if (step === "code") {
        const response = await api("/verify-password-reset-otp", {
          method: "POST",
          body: JSON.stringify({ email: form.email.trim(), code: form.code.trim() }),
        });
        if (!response.success) throw new Error("El código no es válido.");
        setStep("password");
      } else {
        if (form.password.length < 8) throw new Error("La contraseña debe tener al menos 8 caracteres.");
        if (form.password !== form.confirmation) throw new Error("Las contraseñas no coinciden.");
        const response = await api("/change-user-password", {
          method: "POST",
          body: JSON.stringify({ email: form.email.trim(), code: form.code.trim(), password: form.password }),
        });
        if (!response.success) throw new Error("No se pudo actualizar la contraseña.");
        navigate("/account?password=changed", { replace: true });
      }
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="food-app">
      <InternalHeader title={t("newPassword")} backTo="/account" />
      <div className="forgot-page">
        <p>{t("recoverHelp")}</p>
        <form className="auth-card" onSubmit={submit}>
          <label>Correo<input type="email" value={form.email} onChange={(event) => update("email", event.target.value)} disabled={step !== "email"} required /></label>
          {step !== "email" && <label>Código<input value={form.code} onChange={(event) => update("code", event.target.value.toUpperCase())} maxLength={6} disabled={step === "password"} required /></label>}
          {step === "password" && (
            <>
              <label>Nueva contraseña<input type="password" minLength={8} value={form.password} onChange={(event) => update("password", event.target.value)} required /></label>
              <label>Repetir contraseña<input type="password" minLength={8} value={form.confirmation} onChange={(event) => update("confirmation", event.target.value)} required /></label>
            </>
          )}
          {message && <div className="wallet-message">{message}</div>}
          {error && <div className="checkout-error">{error}</div>}
          <button className="auth-submit" disabled={busy} type="submit">
            {busy ? "…" : step === "email" ? t("sendCode") : step === "code" ? t("verifyCode") : t("savePassword")}
          </button>
        </form>
      </div>
    </main>
  );
}
